import React from "react";
import Select from "react-select";

const SelectField = (props) => {
  const customStyles = {
    control: (base, state) => ({
      ...base,
      margin: "0 0",
      minHeight: "58px",
      paddingTop: "1.5rem",
      borderColor: props?.errors && props?.touched ? "red" : "#ced4da",
      boxShadow: state.isFocused ? "0 0 0 0.25rem rgba(13,110,253,.25)" : "none",
    }),
    valueContainer: (base) => ({
      ...base,
      paddingTop: "0.5rem",
    }),
    placeholder: (base) => ({
      ...base,
      color: "lightgray",
      fontSize: "1rem",
    }),
    menuPortal: (base) => ({
      ...base,
      zIndex: 9999, // 👈 ensure it appears above
    }),
    menu: (base) => ({
      ...base,
      zIndex: 9999, // 👈 double ensure!
    }),
  };

  return (
    <div className={`form-floating ${props?.errors && props?.touched && "is-invalid"}`}>
      <Select
        styles={customStyles}
        defaultValue={props?.active}
        options={props?.options}
        name={props?.name}
        id={props?.name}
        menuPortalTarget={document.body} // 👈 crucial line
        {...props}
        placeholder={props?.label}
      />
      <label style={{ color: "lightgray", margin: "-10px 0" }} htmlFor={props.name}>
        {props.label}
      </label>
      {props?.errors && props?.touched ? <div className="text-danger mt-1 p-1 text-small">{props.errors}</div> : null}
    </div>
  );
};

export default SelectField;
